import { ClipboardButton } from "./ClipboardButton";

export const CopyableLink: React.FC<{
  url: string;
  displayText?: string;
  /** Visible copy button label (defaults to icon-only). */
  copyLabel?: string;
}> = ({ url, displayText, copyLabel }) => {
  const trimmed = url.trim();
  const looksLikeEmail = /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(trimmed);
  const hasScheme = /^[a-z][a-z0-9+.-]*:/i.test(trimmed);
  const href = looksLikeEmail && !hasScheme ? `mailto:${trimmed}` : trimmed;

  return (
    <div className="flex items-center gap-2">
      <a
        href={href}
        target="_blank"
        rel="noreferrer"
        className="inline-block min-h-9 flex-1 overflow-hidden truncate rounded border border-gray-300 bg-white px-3 py-1.5 text-sm leading-6 text-gray-900"
        title={url}
      >
        {displayText ?? url}
      </a>
      <ClipboardButton text={url} label={copyLabel} title="Copy link" />
    </div>
  );
};
